import { IconCircleX as TablerIconCircleX } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconCircleX = /*#__PURE__*/ createOutlineIcon(TablerIconCircleX, 'IconCircleX');
